import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import Image from "next/image";
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import Anita from '../../../public/assets/Anita_M.webp';
import Anjali from '../../../public/assets/Anjali_R.webp';
import Arjun from '../../../public/assets/Arjun_D.webp';
import Deepa_N from '../../../public/assets/Deepa_N.webp';
import Lakshmi_R from '../../../public/assets/Lakshmi_R.webp';
import Rahul_S  from '../../../public/assets/Rahul_S.webp';


const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };


function TestimonialsDesktop()
{
    const testimonials = [
        {
            id:1,
            content:
                "“I've been searching for office staff to hire immediately and Lokal matched the right job profiles from my area. Got many suitable candidates to choose from. Best platform to hire!”",
            name: "Sumitra Reddy",
            pos: "Hiring Manager, Telangana",
            image:Anita
        },
        {
            id:2,
            content:
                "“Working as factory manager, You will get staff within one week to come and work from your district itself. Lokal is truly local.”",
            name: "Ravi Kumar",
            pos: "Floor Manager, Tamil Nadu",
            image:Arjun
        },
        {
            id:3,
            content:
                "“I was looking for freshers to hire. Filling details for job post was very simple and my job post was verified and started getting calls within a day. Quick and convenient!”",
            name: "Anjali Desai",
            pos: "Hiring Manager, Telangana",
            image:Anjali
        },
        {
            id:4,
            content:
                "“I was looking for freshers to hire. Filling details for job post was very simple and my job post was verified and started getting calls within a day. Quick and convenient!”",
            name: "Deepa N",
            pos: "Hiring Manager, Telangana",
            image: Deepa_N
        },
        {
            id:5,
            content:
                "“I was looking for freshers to hire. Filling details for job post was very simple and my job post was verified and started getting calls within a day. Quick and convenient!”",
            name: "Lakshmi R",
            pos: "Hiring Manager, Telangana",
            image: Lakshmi_R
        },
        {
            id:6,
            content:
                "“I was looking for freshers to hire. Filling details for job post was very simple and my job post was verified and started getting calls within a day. Quick and convenient!”",
            name: "Rahul S",
            pos: "Hiring Manager, Telangana",
            image: Rahul_S
        },
        
        
        
    ]

    const testimonialChunks = chunkArray(testimonials, window?.innerWidth > 1100 ? 3 : 2)

    return (
      <div id="testimonials" className="px-[80px] mt-[56px]">
        <div className="text-left font-noto-sans text-[48px] font-[600] leading-[31px] text-greyTitleBase900">Testimonials</div>
        <Carousel showIndicators={false} className="mt-[24px] w-[100%] relative" showStatus={false} showArrows={false} showThumbs={false} infiniteLoop={true} renderArrowNext={(onClickHandler)=>{
            return <div onClick={onClickHandler} className="flex justify-center items-center translate-x-[57px] translate-y-[5px] h-[77px]"><ChevronRightOutlinedIcon sx={{width:"34px",height:"34px",border:"1px solid #E5E5E5",borderRadius:"12px"}}/></div>
        }} 
        renderArrowPrev={(onClickHandler)=>{
            return  <div className="flex justify-center items-center translate-x-0 translate-y-[410px]" onClick={(e)=>{
                onClickHandler(e)
            }}><ChevronLeftOutlinedIcon sx={{
                width:"34px",
                height:"34px",
                border:"1px solid #E5E5E5",
                borderRadius:"12px"
            }}/></div>
        }}>
            {
                testimonialChunks.map((chunk,index)=>{
                    return <div key={index} className="">
                    <div className="gap-[10px] grid sm:grid-cols-2 md:grid-cols-3 h-[350px]">
                      {chunk.map(testimonial => (
                        <div key={testimonial.id} className="w-[95%] p-[24px] h-[300px] border-solid border-greyDivider100 rounded-[24px] overflow-y-hidden">
                          <div className="w-[64px] h-[64px] rounded-[16px]">
                            <Image src={testimonial.image} height={64} width={64} className="rounded-[16px]"/>
                          </div>
                          <div className="bg-white text-left">
                          <div className="mt-[24px]">
                              <div className="text-[24px] font-noto-sans font-[600] text-greyTitleBase900">{testimonial.name}</div>
                              <div className="text-[16px] font-noto-sans font-[600] text-greyTertiaryBase500">{testimonial.pos}</div>
                            </div>
                            <p className="text-greyTertiaryBase500 mt-[8px]">{testimonial.content}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>




                })
            }
          
        </Carousel>
      </div>
    )

}

export default TestimonialsDesktop